import { getTeamUrl } from 'Common'

export default (values) => async () => {

  const url = `statistics?date_range=${values.date_range}${values.client_id ? `&client_id=${values.client_id}` : ''}`

  window.location = getTeamUrl(url, 'exports')
}